// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"18be4663","273":"fe359703","488":"33e4b493"}[chunkId] + ".css";
};